import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Translation dictionaries — keep concise, target key marketing strings.
const resources = {
  en: {
    translation: {
      nav: { home: "Home", markets: "Markets", bots: "AI Trading", predict: "Predict", earn: "Earn", about: "About", help: "Help", contact: "Contact", signin: "Sign in", signup: "Sign up" },
      hero: {
        eyebrow: "AI-powered crypto trading ecosystem",
        title_a: "Trade Smarter With",
        title_b: "AI-powered trading, prediction markets, and a connected Web3 ecosystem —",
        title_c: "built to make digital finance simple, accessible, and rewarding.",
        subtitle: "AI Trading Bot, AI DEX Sniper, and AI Meme Sniper working around the clock — designed for beginners, engineered for pros.",
        placeholder: "Enter your email", cta_signup: "Sign up", cta_explore: "Explore the ecosystem", google: "Continue with Google",
        promo: "AI-powered trading · Non-custodial wallet · Building 2026–2030",
        promo_cta: "Get Started",
        reward: "Join FutureChain today and take the first step toward smarter trading",
        stats: { engines: "AI trading engines", products: "Ecosystem products", roadmap: "Roadmap" },
      },
      bots: { eyebrow: "AI Trading Suite", title_a: "AI Trading Bot, DEX Sniper, Meme Sniper. ", title_b: "One connected suite.", subtitle: "No coding, no manual monitoring. Choose an engine and let FutureChain's AI scan markets, spot opportunities, and execute around the clock.", see_all: "Explore the suite" },
      security: { eyebrow: "Fund security", title_a: "Your assets, ", title_b: "our first principle", subtitle: "Three pillars keep your capital protected — regulated, monitored, and verifiable." },
      cta_final: { title_a: "Trade smarter with ", title_b: "AI, built for the future", title_c: ".", subtitle: "Join FutureChain and explore AI-powered trading, prediction markets, and a connected Web3 ecosystem — built for the next generation of investors.", cta: "Get Started" },
      common: { learn_more: "Learn more", try_it: "Try it", live: "Live", loading: "Loading…" },
    },
  },
  es: {
    translation: {
      nav: { home: "Inicio", markets: "Mercados", bots: "Trading IA", predict: "Predicción", earn: "Ganar", about: "Nosotros", help: "Ayuda", contact: "Contacto", signin: "Iniciar sesión", signup: "Registrarse" },
      hero: {
        eyebrow: "Ecosistema de trading cripto con IA",
        title_a: "Opera más inteligente con", title_b: "Trading con IA, mercados de predicción y un ecosistema Web3 conectado —", title_c: "creado para que las finanzas digitales sean simples, accesibles y gratificantes.",
        subtitle: "AI Trading Bot, AI DEX Sniper y AI Meme Sniper trabajando las 24 horas — diseñado para principiantes, creado para profesionales.",
        placeholder: "Tu correo electrónico", cta_signup: "Registrarse", cta_explore: "Explorar el ecosistema", google: "Continuar con Google",
        promo: "Trading con IA · Billetera no custodial · Construyendo 2026–2030",
        promo_cta: "Empezar",
        reward: "Únete a FutureChain hoy y da el primer paso hacia un trading más inteligente",
        stats: { engines: "Motores de trading con IA", products: "Productos del ecosistema", roadmap: "Hoja de ruta" },
      },
      bots: { eyebrow: "Suite de trading IA", title_a: "AI Trading Bot, DEX Sniper, Meme Sniper. ", title_b: "Una sola suite conectada.", subtitle: "Sin código, sin monitoreo manual. Elige un motor y deja que la IA de FutureChain escanee mercados, detecte oportunidades y ejecute las 24 horas.", see_all: "Explorar la suite" },
      security: { eyebrow: "Seguridad de fondos", title_a: "Tus activos, ", title_b: "nuestro primer principio", subtitle: "Tres pilares protegen tu capital — regulado, monitoreado y verificable." },
      cta_final: { title_a: "Opera más inteligente con ", title_b: "IA, creada para el futuro", title_c: ".", subtitle: "Únete a FutureChain y explora trading con IA, mercados de predicción y un ecosistema Web3 conectado — creado para la próxima generación de inversores.", cta: "Empezar" },
      common: { learn_more: "Saber más", try_it: "Probar", live: "En vivo", loading: "Cargando…" },
    },
  },
  hi: {
    translation: {
      nav: { home: "होम", markets: "मार्केट", bots: "AI ट्रेडिंग", predict: "प्रेडिक्शन", earn: "कमाएँ", about: "हमारे बारे में", help: "मदद", contact: "संपर्क", signin: "साइन इन", signup: "साइन अप" },
      hero: {
        eyebrow: "AI-पावर्ड क्रिप्टो ट्रेडिंग इकोसिस्टम",
        title_a: "स्मार्ट ट्रेडिंग करें", title_b: "AI-पावर्ड ट्रेडिंग, प्रेडिक्शन मार्केट्स और एक कनेक्टेड Web3 इकोसिस्टम —", title_c: "डिजिटल फाइनेंस को सरल, सुलभ और रिवॉर्डिंग बनाने के लिए बनाया गया।",
        subtitle: "AI Trading Bot, AI DEX Sniper और AI Meme Sniper 24/7 काम करते हुए — शुरुआती लोगों के लिए आसान, प्रोफेशनल्स के लिए दमदार।",
        placeholder: "अपना ईमेल दर्ज करें", cta_signup: "साइन अप", cta_explore: "इकोसिस्टम देखें", google: "Google से जारी रखें",
        promo: "AI-पावर्ड ट्रेडिंग · नॉन-कस्टोडियल वॉलेट · 2026–2030 का निर्माण",
        promo_cta: "शुरू करें",
        reward: "आज ही FutureChain जॉइन करें और स्मार्ट ट्रेडिंग की ओर पहला कदम बढ़ाएँ",
        stats: { engines: "AI ट्रेडिंग इंजन", products: "इकोसिस्टम प्रोडक्ट्स", roadmap: "रोडमैप" },
      },
      bots: { eyebrow: "AI ट्रेडिंग सुइट", title_a: "AI Trading Bot, DEX Sniper, Meme Sniper। ", title_b: "एक कनेक्टेड सुइट।", subtitle: "कोई कोडिंग नहीं, कोई मैनुअल निगरानी नहीं। एक इंजन चुनें और FutureChain का AI मार्केट स्कैन करे, अवसर पहचाने और 24/7 execute करे।", see_all: "सुइट देखें" },
      security: { eyebrow: "फंड सुरक्षा", title_a: "आपके फंड, ", title_b: "हमारा पहला सिद्धांत", subtitle: "तीन स्तंभ आपकी पूँजी की रक्षा करते हैं — विनियमित, निगरानी और सत्यापन।" },
      cta_final: { title_a: "स्मार्ट ट्रेड करें ", title_b: "AI के साथ, भविष्य के लिए बनाया गया", title_c: "।", subtitle: "FutureChain से जुड़ें और AI-पावर्ड ट्रेडिंग, प्रेडिक्शन मार्केट्स और एक कनेक्टेड Web3 इकोसिस्टम देखें — अगली पीढ़ी के निवेशकों के लिए बनाया गया।", cta: "शुरू करें" },
      common: { learn_more: "और जानें", try_it: "आज़माएँ", live: "लाइव", loading: "लोड हो रहा है…" },
    },
  },
  zh: {
    translation: {
      nav: { home: "首页", markets: "行情", bots: "AI 交易", predict: "预测市场", earn: "赚币", about: "关于", help: "帮助", contact: "联系", signin: "登录", signup: "注册" },
      hero: {
        eyebrow: "AI 驱动的加密交易生态系统",
        title_a: "携手", title_b: "AI 驱动的交易、预测市场与互联的 Web3 生态系统，", title_c: "让数字金融变得简单、易用且有价值。",
        subtitle: "AI Trading Bot、AI DEX Sniper 与 AI Meme Sniper 全天候运行 —— 为新手而设计，为专业交易者而打造。",
        placeholder: "输入邮箱", cta_signup: "注册", cta_explore: "探索生态系统", google: "使用 Google 继续",
        promo: "AI 驱动交易 · 非托管钱包 · 2026–2030 建设中",
        promo_cta: "立即开始",
        reward: "立即加入 FutureChain，迈出更智能交易的第一步",
        stats: { engines: "AI 交易引擎", products: "生态系统产品", roadmap: "路线图" },
      },
      bots: { eyebrow: "AI 交易套件", title_a: "AI Trading Bot、DEX Sniper、Meme Sniper。 ", title_b: "一体化互联套件。", subtitle: "无需代码，无需人工盯盘。选择一个引擎，让 FutureChain 的 AI 全天候扫描市场、发现机会并自动执行。", see_all: "探索套件" },
      security: { eyebrow: "资金安全", title_a: "您的资产, ", title_b: "我们的第一原则", subtitle: "三大支柱守护您的资本 —— 合规、监控、可验证。" },
      cta_final: { title_a: "携手 ", title_b: "面向未来打造的 AI，交易更智能", title_c: "。", subtitle: "加入 FutureChain，探索 AI 驱动的交易、预测市场与互联的 Web3 生态系统 —— 为新一代投资者打造。", cta: "立即开始" },
      common: { learn_more: "了解更多", try_it: "试试", live: "实时", loading: "加载中…" },
    },
  },
  ja: {
    translation: {
      nav: { home: "ホーム", markets: "マーケット", bots: "AI取引", predict: "予測市場", earn: "稼ぐ", about: "会社概要", help: "ヘルプ", contact: "お問い合わせ", signin: "ログイン", signup: "登録" },
      hero: {
        eyebrow: "AIを活用した暗号資産取引エコシステム",
        title_a: "スマートに取引しよう、", title_b: "AIを活用した取引・予測市場・つながるWeb3エコシステム —", title_c: "デジタル金融をシンプルで身近、そして価値あるものにするために。",
        subtitle: "AI Trading Bot、AI DEX Sniper、AI Meme Sniperが24時間稼働 — 初心者にもやさしく、プロにも本格的。",
        placeholder: "メールアドレス", cta_signup: "登録", cta_explore: "エコシステムを見る", google: "Google で続行",
        promo: "AIを活用した取引 · ノンカストディアルウォレット · 2026–2030年構築中",
        promo_cta: "始める",
        reward: "今すぐ FutureChain に参加し、スマートな取引への第一歩を踏み出そう",
        stats: { engines: "AI取引エンジン", products: "エコシステム製品", roadmap: "ロードマップ" },
      },
      bots: { eyebrow: "AI取引スイート", title_a: "AI Trading Bot、DEX Sniper、Meme Sniper。 ", title_b: "つながる1つのスイート。", subtitle: "コード不要、手動監視も不要。エンジンを選べば、FutureChainのAIが市場をスキャンし、チャンスを見つけて24時間執行します。", see_all: "スイートを見る" },
      security: { eyebrow: "資金の安全", title_a: "あなたの資産、", title_b: "私たちの第一原則", subtitle: "3 つの柱があなたの資本を守ります — 規制、監視、検証可能。" },
      cta_final: { title_a: "未来のために作られた ", title_b: "AIで、もっとスマートに取引", title_c: "。", subtitle: "FutureChainに参加して、AIを活用した取引、予測市場、つながるWeb3エコシステムを体験しよう — 次世代の投資家のために。", cta: "始める" },
      common: { learn_more: "詳細", try_it: "試す", live: "ライブ", loading: "読み込み中…" },
    },
  },
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "futurechain_lang" },
});

export default i18n;

export const LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "hi", label: "हिन्दी" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
];
